export default __webpack_public_path__ + "static/media/drop-arrow.6788c16b.svg";